// extracted by mini-css-extract-plugin
module.exports = {"outter":"Button_outter__1wmdp","inner":"Button_inner__xEr2C","text":"Button_text__1n7uF"};